const applyArchive = () => {
  const archive = document.querySelector(`.archive`);

  if (archive) {
    const archiveList = archive.querySelector(`.archive__list`);
    const archiveButton = archive.querySelector(`.archive__button`);
    const archiveItems = archive.querySelectorAll(`.archive__item`);
    const archiveSublists = archive.querySelectorAll(`.archive__sublist`);

    const closeUnit = (unit) => {
      unit.classList.add(`js-isClose`);
    };

    const openUnit = (unit) => {
      unit.classList.remove(`js-isClose`);
    };

    const toggleUnit = (unit) => {
      unit.classList.toggle(`js-isClose`);
    };

    const closeArchive = () => {
      archiveSublists.forEach((sublist) => closeUnit(sublist));
      archiveItems.forEach((archiveItem) => openUnit(archiveItem));
      closeUnit(archiveList);
    };

    const handleArchiveButtonClick = () => {
      if (archiveList.classList.contains(`js-isClose`)) {
        openUnit(archiveList);
      } else {
        closeArchive();
      }
    };

    const handleDocumentClick = (event) => {
      if (!archiveList.classList.contains(`js-isClose`) && event.target !== archiveButton && !event.target.classList.contains(`archive__subbutton`)) {
        closeArchive();
      }
    };

    closeArchive();
    archiveButton.addEventListener(`click`, handleArchiveButtonClick);
    document.addEventListener(`click`, (event) => handleDocumentClick(event));

    if (archiveItems) {
      archiveItems.forEach((currentArchiveItem) => {
        const subbutton = currentArchiveItem.querySelector(`.archive__subbutton`);
        const sublist = currentArchiveItem.querySelector(`.archive__sublist`);

        const toggleOthersItems = () => {
          archiveItems.forEach((archiveItem) => {
            if (archiveItem !== currentArchiveItem) {
              toggleUnit(archiveItem);
            }
          });
        };

        if (subbutton && sublist) {
          closeUnit(subbutton);

          subbutton.addEventListener(`click`, () => {
            toggleOthersItems();
            toggleUnit(sublist);
          });
        }
      });
    }
  }

};


export {
  applyArchive
};
